import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Editor from "../../components/Editor";
import InputFieldDebounce from "../../components/ui/InputFieldDebounce";
import SelectItem from "../../main/component/SelectItem";

const NoteForm = ({
  eventData,
  onDataChange,
  onChangeMentionedMembers,
  validationErrors,
  editorInputDescriptionRef,
}) => {
  const { t } = useTranslation();

  const members = useSelector((state: any) => state.projectReducer.getIn(["project", "members"]));

  const handleChangeField = (fieldId, fieldValue) => {
    onDataChange(fieldId, fieldValue);
  };

  const handleSelectSearchItem = (searchItem) => {
    const item = {
      value: searchItem.get("id"),
      label: searchItem.getIn(["data", "name", "value"]),
      type: searchItem.get("type"),
    };
    handleChangeField("item", item);
  };

  return (
    <div className="min-w-2xl space-y-4">
      <div>
        <InputFieldDebounce
          label={t("Title")}
          placeholder={t("Type...")}
          value={eventData.summary}
          onChange={(value) => handleChangeField("summary", value)}
          errorMessage={validationErrors.summary}
        />
      </div>
      <div>
        <div className="w-full">
          <label className="block text-sm font-semibold text-gray-800 mb-2">{t("Content")}</label>
          <div className="max-w-2xl rounded-lg border border-gray-300 [&_.ql-container]:!border-0">
            <Editor
              editorInputRef={editorInputDescriptionRef}
              showToolbar={false}
              minRows={4}
              members={members}
              editorContent={{
                htmlContent: eventData.description,
                contents: {},
              }}
              onChange={(content) => {
                onChangeMentionedMembers(content.mentionedMembers);
                handleChangeField("description", content.htmlContent);
              }}
            />
          </div>
          {validationErrors.description && (
            <p className="text-xs text-red-600 mt-1">{validationErrors.description}</p>
          )}
        </div>
      </div>
      <div>
        <div className="w-full">
          <label className="block text-sm font-semibold text-gray-800 mb-2">
            {t("Linked Item")}
          </label>
          <div className="flex items-center">
            <SelectItem
              selectedItem={eventData.item}
              onSelectItem={(searchItem) => {
                if (searchItem.get("id")) {
                  handleSelectSearchItem(searchItem);
                } else {
                  handleChangeField("item", {
                    type: searchItem.get("type"),
                  });
                }
              }}
            />
          </div>
          {validationErrors.linkItem && (
            <p className="text-xs text-red-600 mt-1">{validationErrors.linkItem}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoteForm;
